"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 6a2.7 2.7 0 0 1 2.7-2.7h6.626a2.7 2.7 0 0 1 2.7 2.7v1.65A2.7 2.7 0 0 1 17 10.25v2.832a2.7 2.7 0 0 1-2.7 2.7h-1.667a2.3 2.3 0 0 0-1.251.37l-1.52.985A1.2 1.2 0 0 1 8.01 16.13v-.29a.06.06 0 0 0-.06-.058 2.22 2.22 0 0 1-2.217-2.218v-1.529H5.7a2.7 2.7 0 0 1-2.7-2.7zm2.733 4.635v-.385a2.7 2.7 0 0 1 2.7-2.7h5.194V6a1.3 1.3 0 0 0-1.3-1.3H5.7A1.3 1.3 0 0 0 4.4 6v3.335a1.3 1.3 0 0 0 1.3 1.3zm2.7-1.685a1.3 1.3 0 0 0-1.3 1.3v3.314c0 .451.366.818.818.818.78 0 1.416.611 1.457 1.381l1.213-.786a3.7 3.7 0 0 1 2.012-.595H14.3a1.3 1.3 0 0 0 1.3-1.3V10.25a1.3 1.3 0 0 0-1.3-1.3z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ConversationsIcon20.js.map